import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Hero.css';

function Hero() {
  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <span className="hero-eyebrow">Software &amp; digital solutions</span>
          <h1>Build Smarter Digital Systems for Your Business</h1>
          <p>
            Web development, e-commerce, integrations and intelligent automation designed to
            help businesses grow and operate more efficiently.
          </p>
          <div className="hero-actions">
            <Link to="/contact" className="hero-button hero-button-primary">
              Discuss Your Project
            </Link>
            <Link to="/services" className="hero-button hero-button-secondary">
              Explore Our Services
            </Link>
          </div>
        </div>

        <div className="hero-visual" aria-hidden="true">
          <div className="hero-orbit hero-orbit-outer"></div>
          <div className="hero-orbit hero-orbit-inner"></div>
          <div className="hero-system-core">
            <span>B</span>
            <small>Digital systems</small>
          </div>
          <div className="hero-system-card hero-system-card-build">
            <span>01</span>
            <strong>Build</strong>
          </div>
          <div className="hero-system-card hero-system-card-connect">
            <span>02</span>
            <strong>Connect</strong>
          </div>
          <div className="hero-system-card hero-system-card-automate">
            <span>03</span>
            <strong>Automate</strong>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
